import { useState } from "react";
import { ChevronRight } from "lucide-react";

interface ActivityGroupProps {
  activities: string[];
}

export function ActivityGroup({ activities }: ActivityGroupProps) {
  const [open, setOpen] = useState(false);

  if (activities.length === 0) return null;

  // Single activity: show inline, no collapse
  if (activities.length === 1) {
    return (
      <div className="flex justify-center">
        <div className="text-2xs text-intri-muted py-1 flex items-center gap-2">
          <div className="h-px flex-1 bg-intri-border min-w-[24px]" />
          <span>{activities[0]}</span>
          <div className="h-px flex-1 bg-intri-border min-w-[24px]" />
        </div>
      </div>
    );
  }

  // Multiple activities: collapsible
  return (
    <div className="flex justify-center">
      <div className="w-full">
        <button
          onClick={() => setOpen(!open)}
          className="w-full text-2xs text-intri-muted py-1 flex items-center gap-2 hover:text-intri-dim transition-colors"
        >
          <div className="h-px flex-1 bg-intri-border" />
          <ChevronRight
            size={10}
            className={`shrink-0 transition-transform duration-200 ${open ? "rotate-90" : ""}`}
          />
          <span className="shrink-0">
            {activities.length} actions
          </span>
          <div className="h-px flex-1 bg-intri-border" />
        </button>

        {open && (
          <div className="mt-1 mb-1 space-y-0.5 animate-fade-in">
            {activities.map((activity, i) => (
              <p key={i} className="text-2xs text-intri-muted/70 pl-6 truncate">
                {activity}
              </p>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
